import { useId } from "react";

import { Button } from "@/components/ui/button";
import { FloatingPanel } from "@/components/ui/floating-panel";
import { Input } from "@/components/ui/input";

interface ManualCalibrationPopoverProps {
  customDistanceInput: string;
  validationError: string | null;
  onCustomDistanceInputChange: (value: string) => void;
  onApply: () => void;
  onCancel: () => void;
}

export function ManualCalibrationPopover({
  customDistanceInput,
  validationError,
  onCustomDistanceInputChange,
  onApply,
  onCancel,
}: ManualCalibrationPopoverProps) {
  const errorId = useId();
  return (
    <FloatingPanel className="pointer-events-auto w-48" title="Calibrate">
      <Input
        aria-label="Calibration distance"
        aria-invalid={validationError ? true : undefined}
        aria-describedby={validationError ? errorId : undefined}
        placeholder={'10\'-6"'}
        value={customDistanceInput}
        onChange={(event) => onCustomDistanceInputChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            onApply();
          }
        }}
        className="mb-2 h-8 px-2 text-sm"
        autoFocus
      />
      <div className="flex gap-2">
        <Button size="sm" className="flex-1" onClick={onApply}>
          Apply
        </Button>
        <Button size="sm" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
      {validationError ? (
        <div id={errorId} role="alert" className="mt-2 text-[11px] leading-tight text-destructive">
          {validationError}
        </div>
      ) : null}
    </FloatingPanel>
  );
}
